// extracted by mini-css-extract-plugin
export var active = "_ke-e";
export var blink = "_ke-f";
export var dropDownSelector = "_ke-5";
export var dropDownWrapper = "_ke-4";
export var fakeCursor = "_ke-d";
export var fontSizeButton = "_ke-7";
export var formQuillEditor = "_ke-0";
export var pressed = "_ke-g";
export var qlBlank = "_ke-1";
export var textFormattingToolbar = "_ke-2";
export var textFormattingToolbarClosed = "_ke-3";
export var textFormattingToolbarInline = "_ke-6";
export var textToolbarOption = "_ke-8";
export var toolbarCell = "_ke-a";
export var toolbarCellCollapsed = "_ke-b";
export var toolbarOptionHitArea = "_ke-c";
export var toolbarOverflow = "_ke-9";